import types from '../../constants';

const initialState = {
  loading: false,
  valid: false,
  redirectToLogin: false,
  hello: 'bonbon'
};

const ValidateTokenReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.VALIDATE_INITIAL:
      return {
        ...state,
        loading: false,
        valid: false,
        redirectToLogin: false
      };
    case types.VALIDATE_START:
      return {
        ...state,
        loading: true,
        redirectToLogin: false
      };
    case types.VALIDATE_FAILED:
      return {
        ...state,
        loading: false,
        redirectToLogin: true
      };
    case types.VALIDATE_END:
      return {
        ...state,
        loading: false,
        valid: action.payload,
        redirectToLogin: false
      };
    default:
      return state;
  }
};

export default ValidateTokenReducers;
